import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggests';

import { routes } from '../../../redux/api/routes';
const {
	orders,
	bootAPIUrl,
} = routes;
import {
	sendRequest
} from '../../../redux/api/sendRequest';

/* Dialogs */
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

/* Actions */
import {
	getInvoices,
	getInvoicePDF,
	getOrderList,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
} from '../../../redux/actions';

const INVOICE_NUMBER_LABEL = "AR Invoice Number";
const SALES_ORDERNUMBER_LABEL = "Sales Order Number";
const CSO_LABEL = "Order Number";
const PO_NUMBER_LABEL = "Customer PO Number";
const INVOICE_DATE_LABEL = "AR Invoice Date";
const INVOICE_AMOUNT_LABEL = "AR Invoice Total";
const SOLD_TO_CUSTOMER_NUMBER = "Sold to Customer Account Number";
const CUSTOMER_ACCOUNT_NUMBER ="Customer Account Number";
const ACCOUNT_NUMBER ="Account Number";
const INVOICE_NUMBER ="Invoice Number";
const INVOICE_DATE = "Invoice Date"
const INVOICE_AMOUNT = "Invoice Amount";

class ViewInvoices extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showGenericOverlayDialog: false,
			genericDialogHeading: "",
			genericDialogText: "",
			modalButtons: "",

			errorMessage: '',

			fromDate: null,
			toDate: null,
			minFromDate: null,
			minToDate: null,
			maxFromDate: moment(),
			maxToDate: moment(),
			dateRangeErrorMessage: '',

			groupOfInvoices: {
				param: {
					fromDate: null,
					toDate: null,
				},
				error: {
					fromDateError: '',
					toDateError: '',
				}
			},

			filterListOfInvoices: {
				param: {
					filterBy: '',
					filterString: ''
				},
				error: {
					filterByError: '',
					filterStringError: '',
					modelNumberError: '',
					serialNumberError: '',
					chrmClaimNumberError:''
				}
			},

			invoicesList: null,
		}
		// this.hideFilterResultMessage = this.hideFilterResultMessage.bind(this);
		this.getInvoices = this.getInvoices.bind(this);
		this.handleChangeFromDate = this.handleChangeFromDate.bind(this);
		this.handleChangeToDate = this.handleChangeToDate.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleChangeFromDate(date) {
	  	const self = this;
		let { minToDate, maxToDate, maxFromDate, minFromDate, toDate } = self.state;
		if(date && !toDate) {
			const dt = date.format('MM/DD/YYYY');
			minFromDate = moment(dt);
			minToDate = moment(dt);
			maxFromDate = moment(dt).add(90, 'day');
			maxToDate = moment(dt).add(90, 'day');
		} else if(!date && !toDate) {
			minFromDate = null;
			maxFromDate = moment();
			minToDate = null;
			maxToDate = moment();
		}
		if(maxFromDate && maxFromDate.isAfter(moment())) {
			maxFromDate = moment();
			minFromDate = moment().add(-90, 'day');
		}
		if(maxToDate && maxToDate.isAfter(moment())) {
			maxToDate = moment();
			minToDate = moment().add(-90, 'day');
		}
	  	self.setState({
			minToDate, maxToDate, maxFromDate, minFromDate,
		  	fromDate: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : null,
			groupOfInvoices: {
				...self.state.groupOfInvoices,
				param: {
					...self.state.groupOfInvoices.param,
			  		fromDate: date && date.format('MM/DD/YYYY')
				},
				error: {
					...self.state.groupOfInvoices.error,
					fromDateError: ""
				}
		  	},
			dateRangeErrorMessage: '',
	  	});
	}

	handleChangeToDate(date) {
		const self = this;
		let { minToDate, maxToDate, maxFromDate, minFromDate, fromDate } = self.state;
		if(date && !fromDate) {
			const dt = date.format('MM/DD/YYYY');
			minFromDate = moment(dt).add(-90, 'day');
			minToDate = moment(dt).add(-90, 'day');
			maxFromDate = moment(dt);
			maxToDate = moment(dt);
		} else if(!date && !fromDate) {
			minFromDate = null;
			maxFromDate = moment();
			minToDate = null;
			maxToDate = moment();
		}
		// if(maxFromDate && maxFromDate.isAfter(moment())) {
		// 	maxFromDate = moment();
		// 	minFromDate = moment().add(-90, 'day');
		// }
		// if(maxToDate && maxToDate.isAfter(moment())) {
		// 	maxToDate = moment();
		// 	minToDate = moment().add(-90, 'day');
		// }
	  	self.setState({
			minToDate, maxToDate, maxFromDate, minFromDate,
		  	toDate: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : null,
			groupOfInvoices: {
				...self.state.groupOfInvoices,
				param: {
					...self.state.groupOfInvoices.param,
			  		toDate: date && date.format('MM/DD/YYYY')
				},
				error: {
					...self.state.groupOfInvoices.error,
					toDateError: ""
				}
		  	},
			dateRangeErrorMessage: '',
	  	});
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this,
			accountNumber = self.props.getSelectedAccountNumber();
		// redirect user to home page if he has not access to this page
		if(!self.props.isResponsibilityExists('Invoices and Payments')) {
			browserHistory.push('/home');
		}
		if(accountNumber) {
			self.setState({
				accountNumber: accountNumber
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	getInvoices(queryString, callback) {
		const self = this;
		self.setState({
			errorMessage: '',
			invoicesList: null,
		}, () => {
			const whichCall = self.state.isSerialNumberSearch ? 'getOrderList' : 'getInvoices';
			self.props[whichCall](queryString, (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else if(!response.responseObject) {
					self.setState({
						invoicesList: []
					});
				} else {
					if(self.state.isSerialNumberSearch) {
						response.responseObject = response.responseObject;

						// Filter line_TYPE === "Standard Line" for all users
						response.responseObject = response.responseObject.filter(item => item.line_TYPE === "Standard Line" && item.account_NUMBER === self.props.getSelectedAccountNumber());

						if (response.responseObject.length === 0 && self.state.isNextServiceCallRequired) {
							self.setState({
								isNextServiceCallRequired: false,
							}, () => {
								self.getInvoices(self.state.queryStringBkp, callback);
							});
						} else {
							const promises = [];
							self.props.ajaxRequestInitiated();
							response.responseObject.forEach(item => {
								promises.push(
									sendRequest(
										bootAPIUrl,
										orders.invoice.path,
										'',
										orders.invoice.method,
										`requestType=getInvoices&accountNumber=${self.state.accountNumber}&invoiceNumber=${item.invoice_NUMBER}`
									)
								);
							});
							Promise.all(promises).then((responses) => {
								// logic to combine all responses and then run call back
								let responseObject = [];
								let response = {};
								if(responses.length > 0) {
									responses.forEach(resp => {
										responseObject = responseObject.concat(resp.responseObject);
									});
									response = {
										...responses[0],
										responseObject
									}
								} else {
									self.setState({
										invoicesList: []
									});
									response.responseObject = [];
								}
								self.props.ajaxRequestCompleted();
								self.processAndFilterResponse({
									...response,
									responseObject: response.responseObject[0]
								},queryString, callback);
							});
						}
					} else {
						self.processAndFilterResponse(response, queryString, callback);
					}
				}
			});
		});
	}

	processAndFilterResponse(response, queryString, callback) {
		const self = this;
		const isCLASearch = queryString.includes('chrmClaimNumber')
		const { columns, results } = response.responseObject;
		const invoicesList = [];
		const invoiceNumberIndex = !isCLASearch ? columns.findIndex(x => x === INVOICE_NUMBER_LABEL) : columns.findIndex(x => (x === INVOICE_NUMBER_LABEL || x === INVOICE_NUMBER));
		const csoIndex = columns.findIndex(x => x === CSO_LABEL || x === SALES_ORDERNUMBER_LABEL);
		const poNumberIndex = columns.findIndex(x => x === PO_NUMBER_LABEL);
		const invoiceDateIndex = !isCLASearch ? columns.findIndex(x => x === INVOICE_DATE_LABEL) : columns.findIndex(x => (x === INVOICE_DATE_LABEL || x === INVOICE_DATE));
		const invoiceAmountIndex = !isCLASearch ? columns.findIndex(x => x === INVOICE_AMOUNT_LABEL) : columns.findIndex(x => (x === INVOICE_AMOUNT_LABEL || x === INVOICE_AMOUNT));
		const soldtocustomernumberIndex = !isCLASearch ? columns.findIndex(x => x === SOLD_TO_CUSTOMER_NUMBER): columns.findIndex(x => (x === CUSTOMER_ACCOUNT_NUMBER || x === ACCOUNT_NUMBER));
		const selectedAccountNumber = self.props.getSelectedAccountNumber();
		results.forEach(item => {
			const { columnValues } = item;
			if(soldtocustomernumberIndex >= 0 && columnValues[soldtocustomernumberIndex].value === selectedAccountNumber) {
				invoicesList.push({
					invoiceNumber: invoiceNumberIndex >= 0 ? columnValues[invoiceNumberIndex].value : '',
					cso: csoIndex >= 0 ? columnValues[csoIndex].value : '',
					poNumber: poNumberIndex >= 0 ? columnValues[poNumberIndex].value : '',
					invoiceDate: invoiceDateIndex >= 0 ? moment(columnValues[invoiceDateIndex].value).format('MM/DD/YYYY') : '',
					invoiceAmount: invoiceAmountIndex >= 0 ? self.props.formatMoney(columnValues[invoiceAmountIndex].value, 0, ".", ",", false, "$") : '',
				});
			}
		});
		callback(invoicesList);
	}

	handleFilterListOfInvoices(event) {
		event.preventDefault();
		const self = this;
		let { filterListOfInvoices, inValid } = this.state;
		let anyError = false;
		if (
			(filterListOfInvoices.param.filterBy === 'orderNumber' && !self.props.isValidOrderNumer(filterListOfInvoices.param.filterString))
		) {
			anyError = true;
		}
		if (
			(filterListOfInvoices.param.filterBy === 'chrmClaimNumber' && !self.props.isValidCLANumber(filterListOfInvoices.param.filterString))
		) {
			anyError = true;
		}
		if(!anyError && filterListOfInvoices.param.filterBy !== '' &&
			(
				(filterListOfInvoices.param.filterBy !== 'serialNumber' && filterListOfInvoices.param.filterString !== '') ||
				(!inValid && filterListOfInvoices.param.filterBy === 'serialNumber' && filterListOfInvoices.param.serialNumber !== '' && filterListOfInvoices.param.modelNumber !== '')
			)
		) {
			let queryStringParams = '';
			if(filterListOfInvoices.param.filterBy !== '') {
				if(filterListOfInvoices.param.filterBy !== 'serialNumber' && filterListOfInvoices.param.filterString !== '') {
					let filterString = filterListOfInvoices.param.filterString;
					if(filterListOfInvoices.param.filterBy === 'poNumber') {
						filterString = encodeURIComponent(filterString);
					}
					queryStringParams += `&${filterListOfInvoices.param.filterBy}=${filterString}`;
				} else {
					queryStringParams += `&modelNumber=${filterListOfInvoices.param.modelNumber.trim()}&serialNumber=${filterListOfInvoices.param.serialNumber.trim()}`;
				}
			}
			let isNextServiceCallRequired = false;
			if (filterListOfInvoices.param.filterBy === 'serialNumber' && filterListOfInvoices.param.serialNumber !== '') {
				const searchStr = filterListOfInvoices.param.serialNumber.toLowerCase();
				if(searchStr.indexOf('-ad1') === -1 || searchStr.indexOf('-ad1') !== searchStr.length - 4) {
					isNextServiceCallRequired = true;
				}
			}
			self.setState({
				isSerialNumberSearch: filterListOfInvoices.param.filterBy === 'serialNumber' && filterListOfInvoices.param.serialNumber !== '',
				isNextServiceCallRequired,
				queryStringBkp: isNextServiceCallRequired ? `requestType=requestReturn&accountNumber=${self.state.accountNumber}${queryStringParams}-AD1` : '',
			}, () => {
				self.getInvoices(`requestType=getInvoices&accountNumber=${self.props.getSelectedAccountNumber()}${queryStringParams}`, (response) => {
					self.setState({
						invoicesList: response
					});
				});
			});
		} else {
			let error = self.state.filterListOfInvoices.error;
			if(filterListOfInvoices.param.filterBy === '') {
				error.filterByError = 'error'
			} else {
				if(filterListOfInvoices.param.filterBy === 'serialNumber') {
					error = {
						...error,
						filterStringError: '',
						serialNumberError: filterListOfInvoices.param.serialNumber === '' ? 'error' : '',
						modelNumberError: filterListOfInvoices.param.modelNumber === '' || inValid ? 'error' : '',
					}
				} else {
					error = {
						...error,
						filterStringError: filterListOfInvoices.param.filterString === '' ? 'error' : '',
						serialNumberError: '',
						modelNumberError: '',
					}
				}
			}

			self.setState({
				filterListOfInvoices: {
					...self.state.filterListOfInvoices,
					error: error
				}
			});
		}
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		let error = this.state[formName].error;
		let param = this.state[formName].param;
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				error[key] = '';
			}
		}
		param = {
			...param,
			filterString: event.target.name === 'filterBy'?'':this.state[formName].param.filterString,
			[event.target.name]: event.target.value
		};
		if(formName === 'filterListOfInvoices') {
			if(event.target.name === 'filterBy') {
				param = {
					...param,
					modelNumber: '',
					serialNumber: '',
				}
				error = {
					...error,
					modelNumberError: '',
					serialNumberError: '',
				};
				if(this.modelNumber)
					this.modelNumber.value = '';
				if(this.serialNumber)
					this.serialNumber.value = '';
			}
		}
		this.setState({
			[formName]: {
				param,
				error
			}
		});
	}

	handleResetForm(whichForm, event) {
		const self = this;
		if(whichForm === 'group') {
			self.setState({
				fromDate: null,
				toDate: null,
				minFromDate: null,
				minToDate: null,
				maxFromDate: moment(),
				maxToDate: moment(),
				groupOfInvoices: {
					param: {
						fromDate: null,
						toDate: null,
					},
					error: {
						fromDateError: '',
						toDateError: '',
					}
				},
				dateRangeErrorMessage: '',
			});
		} else {
			self.setState({
				filterListOfInvoices: {
					param: {
						...self.state.filterListOfInvoices.param,
						filterBy: '',
						filterString: ''
					},
					error: {
						...self.state.filterListOfInvoices.error,
						filterByError: '',
						filterStringError: '',
						modelNumberError: '',
						serialNumberError: '',
						chrmClaimNumberError:''
					}
				}
			});
		}
	}

	handleFindGroupsOfInvoices(event) {
		event.preventDefault();
		const self = this;
		let { groupOfInvoices } = this.state;
		self.setState({
			isSerialNumberSearch : false
		});
		if(groupOfInvoices.param.fromDate && groupOfInvoices.param.toDate) {
			if(moment(groupOfInvoices.param.fromDate).isAfter(moment(groupOfInvoices.param.toDate))) {
				self.setState({
					dateRangeErrorMessage: 'To date must be same or after from date',
				});
			} else {
				const queryStringParams = `fromDate=${groupOfInvoices.param.fromDate}&toDate=${groupOfInvoices.param.toDate}`;
				self.getInvoices(`requestType=getInvoices&accountNumber=${self.props.getSelectedAccountNumber()}&${queryStringParams}`, (response) => {
					self.setState({
						invoicesList: response
					});
				});
			}
		} else {
			const error = self.state.groupOfInvoices.error;
			error.fromDateError = groupOfInvoices.param.fromDate ? '' : 'error';
			error.toDateError = groupOfInvoices.param.toDate ? '' : 'error';
			self.setState({
				groupOfInvoices: {
					...self.state.groupOfInvoices,
					error: error
				}
			});
		}
	}

	getInvoiceDocument(invoiceNumber, event) {
		event && event.preventDefault();
		const self = this;
		// second param says whether it needs to be saved into store
		const param = `requestType=getInvoicePDF&invoiceNumber=${invoiceNumber}&accountNumber=${self.props.getSelectedAccountNumber()}`;
		self.props.getInvoicePDF(param, response => {
			if(response.status) {
				if(response.responseObject) {
					window.open(response.responseObject);
				} else {
					// No invoice document found
					self.setState({
						genericDialogHeading: "Invoice",
						genericDialogText: "No invoice document found.",
						modalButtons: 'ok'
					}, () => {
						self.handleDialog("GenericOverlayDialog", true);
					});
				}
			} else {
				browserHistory.push('/error');
			}
		});
	}

	handleProductNumberChange(itemIndex, productDetails) {
		const self = this;
		if(productDetails && productDetails.status) {
			self.setState({
				filterListOfInvoices: {
					...self.state.filterListOfInvoices,
					param: {
						...self.state.filterListOfInvoices.param,
						modelNumber: productDetails.sku
					}
				},
				inValid: false,
			});
		}
	}

	handleChangeProductNumberTextBox(indx, productNumber, productListSuggestion, inValid) {
		const self = this;
		self.setState({
			inValid,
			filterListOfInvoices: {
				param: {
					...self.state.filterListOfInvoices.param,
					modelNumber: productNumber,
				},
				error: {
					...self.state.filterListOfInvoices.error,
					modelNumberError: '',
				}
			},
		});
	}

    render() {
		const self = this;
		const {
			invoicesList,
			filterListOfInvoices: {
				param: {
					filterBy
				}
			},
			groupOfInvoices,
			dateRangeErrorMessage,
			inValid
		} = self.state;
		const isGEAPartsSalesAgreementSelected = this.props.isGEAPartsSalesAgreementSelected();

        return (
			<div>
		        <div className="push">
		          	<h1 className="pageTitle">View Invoices</h1>
		        </div>
				<div className="push">
					<div className="filterBoxType2 particularOrderShadedBox">
						<div style={{float: 'left', width: '43%', position: 'relative'}}>
							<h3 style={{marginBottom: 0, marginTop: 14}}>Search for Groups of Invoices</h3>
							<p style={{marginTop: 0}}>Select a date range of 90 days or less</p>
							<form onSubmit={this.handleFindGroupsOfInvoices.bind(this)}>
								<div className={groupOfInvoices.error.fromDateError + ' float-left date-picker-custom-css'}>
									<strong>From Date</strong><br/>
									<DatePicker id="fromDate" maxDate={self.state.maxFromDate} minDate={self.state.minFromDate} selected={this.state.fromDate} placeholderText="Click to select a date" onChange={this.handleChangeFromDate} />&nbsp;<var>(mm/dd/yyyy)</var>
								</div>
								<div className={groupOfInvoices.error.toDateError + ' float-right date-picker-custom-css'}>
									<strong>To Date</strong><br/>
									<DatePicker id="toDate" maxDate={self.state.maxToDate} minDate={self.state.minToDate} selected={this.state.toDate} placeholderText="Click to select a date" onChange={this.handleChangeToDate} />&nbsp;<var>(mm/dd/yyyy)</var>
								</div>
								<div className="clear" />
								{dateRangeErrorMessage && <p className="red bold">{dateRangeErrorMessage}</p>}
								<p>
									<input className="blueButton" type="submit" value="Search" />
									&nbsp; &nbsp; &nbsp;<input onClick={this.handleResetForm.bind(this, 'group')} className="looksLikeALink blue" type="reset" value="clear search" />
								</p>
							</form>
						</div>
						<div style={{float: 'left', width: '9.995%', position: 'relative', textAlign: 'center'}}>
							<div style={{width: '50%', borderRight: '1px solid #ccc', height: 72}} />
							<h3>OR</h3>
							<div style={{width: '50%', borderRight: '1px solid #ccc', height: 72}} />
						</div>
						<div style={{float: 'left', width: '47%', position: 'relative'}}>
							<h3 style={{marginBottom: 0}}>Search for a Specific Invoice</h3>
							<p style={{marginTop: 0}}>Filter by Invoice #, P.O. # or CSO (order number)</p>
							<form onSubmit={this.handleFilterListOfInvoices.bind(this)}>
								<p>
									<select ref={(select) => this.filterBy = select} defaultValue={this.state.filterListOfInvoices.param.filterBy} name="filterBy" onChange={this.updateParams.bind(this, 'filterListOfInvoices')} className={"fullWidth " + this.state.filterListOfInvoices.error.filterByError}>
										<option value="">Select one...</option>
										{!isGEAPartsSalesAgreementSelected && <option value="serialNumber">Serial #</option>}
										<option value="invoiceNumber">Invoice #</option>
										<option value="poNumber">P.O. #</option>
										<option value="orderNumber">CSO (Order number)</option>
										<option value="chrmClaimNumber">ChRM Claim Number (CLA#)</option>
									</select>
								</p>
								{this.state.filterListOfInvoices.param.filterBy !== 'serialNumber' &&
									<p>
										<input ref={(input) => this.filterString = input} onChange={this.updateParams.bind(this, 'filterListOfInvoices')} className={"fullWidth " + this.state.filterListOfInvoices.error.filterStringError + (filterBy === 'poNumber' || filterBy === 'referenceNumber' ? ' text-transform-uppercase' : '')} type="text" name="filterString" disabled={this.state.filterListOfInvoices.param.filterBy === ''} value={this.state.filterListOfInvoices.param.filterString} />
									</p>}
								{this.state.filterListOfInvoices.param.filterBy === 'serialNumber' &&
									<p className={this.state.filterListOfInvoices.error.modelNumberError + ' auto-width-input'}>
										<AccountNumberAutoSuggests onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)} updateQuickOrderState={this.handleProductNumberChange.bind(this)} size={8} placeHolder="Model #" />
										{inValid
											?<span className="red">Invalid product Number.</span>
											:null
										}
									</p>
								}
								{this.state.filterListOfInvoices.param.filterBy === 'serialNumber' &&
									<p>
										<input placeholder="Serial #" ref={(input) => this.serialNumber = input} onChange={this.updateParams.bind(this, 'filterListOfInvoices')} className={"fullWidth " + this.state.filterListOfInvoices.error.serialNumberError} type="text" name="serialNumber" disabled={this.state.filterListOfInvoices.param.filterBy !== 'serialNumber'} value={this.state.filterListOfInvoices.param.serialNumber} />
									</p>}
								<p>
									<input type="submit" value="Search" />
									&nbsp; &nbsp;
									<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'other')} value="Clear Search" />
								</p>
							</form>
						</div>
						<div className="clear" />
					</div>
	          	</div>
			  	<p className="red bold">{this.state.errorMessage}</p>
				{invoicesList && <div>
					<div className="captionAboveTable captionAboveManageOrdersTable">
						<div className="columns twoColumns">
							<div className="column">
								<div className="bold big">{invoicesList.length} Invoices</div>
							</div>
						</div>
					</div>
					<table className="dataTable viewReturnsTable">
						<thead>
							<tr>
								<th>Invoice Number</th>
								<th className="orderRef">CSO</th>
								<th className="enteredBy">PO Number</th>
								<th className="origOrder">Invoice Date</th>
								<th className="dateEntered">Invoice Amount</th>
							</tr>
						</thead>
						<tbody>
							{invoicesList.length === 0
								?<tr>
									<td colSpan={7}>No orders found meeting the specified criteria; please try your search again.</td>
								</tr>
								:null
							}
							{invoicesList.length > 0 && invoicesList.map((item, index) => {
								return <tr key={index}>
									<td>
										<a className="bold" href="" onClick={this.getInvoiceDocument.bind(this, item.invoiceNumber)}>{item.invoiceNumber}</a>
									</td>
									<td>{item.cso}</td>
									<td>{item.poNumber}</td>
									<td>{item.invoiceDate}</td>
									<td>{item.invoiceAmount}</td>
								</tr>
							})}
						</tbody>
					</table>
				</div>}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
	getInvoices: (queryStringParams, callback) => dispatch(getInvoices(queryStringParams, callback)),
	getInvoicePDF: (queryStringParams, callback) => dispatch(getInvoicePDF(queryStringParams, callback)),
	ajaxRequestInitiated: (data) => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: (data) => dispatch(ajaxRequestCompleted(data)),
});

ViewInvoices = connect(mapStateToProps, mapDispatchToProps)(ViewInvoices);
export default ViewInvoices;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Invoices/viewInvoices.js